import {AfterViewInit, Component, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import * as _ from 'lodash';
import {MessageService} from "primeng/components/common/messageservice";
import {PromocionesService} from "../../../../core/promociones/promociones.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InfoModalComponent} from "../../info-modal.component";
import * as moment from 'moment';
import {SetPrincipalModalComponent} from "../../set-principal-modal-component";
import {CustomValidators} from "../../../../core/validators/custom-validators";
import {DIMENSION, Promociones} from "../../promociones";

declare var $;

@Component({
  selector: 'ganalottodo-promotion',
  templateUrl: 'ganalottodo-promotion.component.html',
  styleUrls: ['ganalottodo-promotion.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GanalottodoPromotionComponent extends Promociones implements AfterViewInit {

  urlSignup: string = "";
  adminUsers: any[] = [];
  fileCodes;
  isForNewUsers = true;


  constructor(
    private formBuilder: FormBuilder,
    public messageService: MessageService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    public promocionesService: PromocionesService
  ) {
    super(promocionesService, messageService);
    this.isGanalottodo = true;
    this.newPromotion = this._route.snapshot.params['promocion'] === 'new';
    this.promotionKey = this._route.snapshot.params['promocion'];
    this.getTypePromotions();
    this.initForm(null);
  }


  ngAfterViewInit() {
    //this.initForm(null);
    this.getGamesForPromotion();
    this.getAdmonUsernames();
    super.ngOnInit();
  }

  removeFromCodes(codigoToRemove) {
    this.organicCodes = this.organicCodes.filter((code) => {
      let keepElement = code != codigoToRemove;
      if (!keepElement) {
        this.codesToRemove.push(codigoToRemove);
      }
      return keepElement;
    });
  }

  removeFromCodesToRemove(codigoToRemove) {
    this.codesToRemove = this.codesToRemove.filter((code) => {
      let keepElement = code != codigoToRemove;
      if (!keepElement) {
        this.organicCodes.push(codigoToRemove);
      }
      return keepElement;
    });
  }

  private getAdmonUsernames() {
    this.promocionesService.getAdminUsernames().subscribe(
      success => {
        console.log('Se muestran los usuarios', success);
        this.adminUsers = success;
      },
      error => {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      }
    );
  }


  initForm(promotionData) {

    this.promotionForm = this.formBuilder.group({
      promotionName: [promotionData ? promotionData.name : '', Validators.required],
      promotionType: [promotionData ? promotionData.typePromotion : '', Validators.required],
      promotionAmount: [promotionData ? promotionData.promotionAmount : '', Validators.required],
      promotionStartDate: [promotionData ? this.builtObjectDate(promotionData.startDate) : '', Validators.required],
      promotionEndtDate: [promotionData ? this.builtObjectDate(promotionData.endDate) : '', Validators.required],
      emailFounder: [promotionData ? promotionData.emailFounder : '', Validators.compose([
        Validators.required,
        CustomValidators.email
      ])],
      startTime: new FormControl(),
      endTime: new FormControl(),
      codeToadd: ["", [Validators.min(3)]],
      promotionDescription: [promotionData ? promotionData.description : '', Validators.required],
      file1: [this.promotion.codeType ? '' : this.getResource(promotionData, 'forward', 'first', 'file1')],
      file2: [this.promotion.codeType ? '' : this.getResource(promotionData, 'forward', 'secondary', 'file2')],
      file3: [this.promotion.codeType ? '' : this.getResource(promotionData, 'forward', 'back', 'file3')],
      file4: [this.getResource(promotionData, 'checkEmail', 'first', 'file4')],
      file5: [this.getResource(promotionData, 'checkEmail', 'footer', 'file5')],
      file6: [this.promotion.codeType ? '' : this.getResource(promotionData, 'checked', 'first', 'file6')],
      file7: [this.promotion.codeType ? '' : this.getResource(promotionData, 'checked', 'back', 'file7')],
      file13: [this.promotion.codeType ? '' : this.getResource(promotionData, 'gratification', 'first', 'file13')],
      file10: [this.promotion.principal === false ? '' : this.getResource(promotionData, 'landing', 'first', 'file10')],
      file11: [this.promotion.principal === false ? '' : this.getResource(promotionData, 'landing', 'secondary', 'file11')],
      file12: [this.promotion.principal === false ? '' : this.getResource(promotionData, 'landing', 'back', 'file12')],
      fileCodes: [''],
      gamesToPromotion: [''],
      accumulatedBalanceForPromotion: promotionData ? promotionData.accumulatedBalanceForPromotion : ''

    });

    this.isForNewUsers = promotionData ? promotionData.forNewMember : false;


    this.promotionForm.patchValue({
      startTime: promotionData ? GanalottodoPromotionComponent.parseTime(promotionData.startTime) : GanalottodoPromotionComponent.parseTime('09:00'),
      endTime: promotionData ? GanalottodoPromotionComponent.parseTime(promotionData.endTime) : GanalottodoPromotionComponent.parseTime('21:15')
    });

  }


  principalPromotion() {
    this.openPrincipalModal();
  }


  fillModel(): FormData {
    console.log('fillMode');
    let formData = new FormData();
    new FormData();
    console.log(this.promotionForm.get('file1').value);
    formData.append("name", this.promotionForm.get('promotionName').value);
    formData.append("description", this.promotionForm.get('promotionDescription').value);
    formData.append("typePromotion", this.promotionForm.get('promotionType').value);
    formData.append("startTime", moment(this.promotionForm.get('startTime').value).format('HH:mm:ss'));
    formData.append("endTime", moment(this.promotionForm.get('endTime').value).format('HH:mm:ss'));
    formData.append("active", this.promotionActive + '');
    formData.append("principal", this.promotion.principal + '');
    formData.append("startDate", this.builtDate(this.promotionForm.value.promotionStartDate).toDateString());
    formData.append("endDate", this.builtDate(this.promotionForm.value.promotionEndtDate).toDateString());
    formData.append("codeType", this.promotion.codeType + '');
    formData.append("emailFounder", this.promotionForm.get('emailFounder').value);
    formData.append("promotionAmount", this.promotionForm.get('promotionAmount').value);
    formData.append("forNewMember", this.isForNewUsers + '');
    formData.append("accumulatedBalanceForPromotion", this.promotionForm.get('accumulatedBalanceForPromotion').value ? this.promotionForm.get('accumulatedBalanceForPromotion').value : '');
    // console.log('FileCodes: ', this.fileCodes.size);
    // console.log('FileCodes: ', this.fileCodes.name);
    if (this.fileCodes) {
      formData.append("fileCodes", this.fileCodes, this.fileCodes.name);
    }

    _.forEach(this.promotionList, component => {
      formData.append("templateName", component.templateName);
      formData.append("imageName", component.imageName);
      formData.append("imagePosition", component.imagePosition);
      formData.append("resources", component.resources);
    });

    this.codesToAdd.forEach((code) => {
      formData.append("codesToAdd", code);
    });

    this.promotionTriggersToSave.forEach((triggerId) => {
      formData.append("promotionTriggerIds", triggerId);
    });

    this.codesToRemove.forEach((code) => {
      formData.append("codesToRemove", code.code);
    });

    this.gamesToAddInPromotion.forEach(game => {
      formData.append('gamesToPromotion', game);
    });

    this.gamesToDeleteInPromotion.forEach(game => {
      formData.append('gamesToDeletePromotion', game);
    });


    return formData;
  }

  upFileCodes(inputid) {
    $("#" + inputid).prop('type', 'file');
    $("#" + inputid).trigger('click');
  }

  upFile(inputid) {
    $("#" + inputid).prop('type', 'file');
    $("#" + inputid).trigger('click');
  }

  builtDate(dateAsObject): Date {
    const date = new Date(dateAsObject.year, dateAsObject.month - 1, dateAsObject.day);
    console.log(date);
    return date;
  }

  builtObjectDate(valueAsLong): any {
    const date = new Date(+valueAsLong);
    const dateResult = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
    return dateResult;
  }


  setPreviewImage(principalEvent) {
    var fReader = new FileReader();
    fReader.readAsDataURL(principalEvent.target.files[0]);
    fReader.onloadend = function (event: any) {
      let img: any = document.getElementById('up' + principalEvent.srcElement.id);
      img.src = event.target.result;
    };
  }


  /* protected */
  infoImg(file: string) {
    let fileId = _.find(DIMENSION, item => {
      return item.component == file;
    });
    const modalRef = this.modalService.open(InfoModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.imgURL = fileId.imageInfo;
    modalRef.componentInstance.dimensiones = fileId.width + 'px (ancho) X ' + fileId.height + 'px (alto)';
    modalRef.result.then((result) => {
    }, (reason) => {
      console.log(reason);
    });
  }

  private static parseTime(time: string): Date {

    let momentDate = moment();
    let data = time.split(':');

    momentDate.hours(parseInt(data[0]));
    momentDate.minutes(parseInt(data[1]));
    momentDate.seconds(0);
    momentDate.milliseconds(0);

    return momentDate.toDate();
  }

  goBack(promotionType) {
    console.log('GanalottodoPromotionComponent#goBack:promotionType', promotionType);
    if (promotionType === 'game') {
      promotionType = 'promotionsGames';
    } else {
      promotionType = 'saldosGanalottodo';
    }
    this.router.navigate(['/ganalottodo/promotionsGanalottodo/' + promotionType]);
  }

  openPrincipalModal() {
    const modalRef = this.modalService.open(SetPrincipalModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.promocion = this.promotion;

    modalRef.result.then((result) => {
      console.log(result);
      if (result != 'close')
        this.promotion.principal = result;
      if (this.promotion.principal && this.promotionKey != 'new') {
        setTimeout(() => {
          this.initForm(this.promotion);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  addCode() {
    let codeToadd = this.promotionForm.get('codeToadd').value;
    if (this.codesToAdd.indexOf(codeToadd) == -1) {
      this.codesToAdd.push(codeToadd);
      this.promotionForm.patchValue({
        codeToadd: ""
      });
    }
  }

  removeFromCodesToAdd(codeToRemove) {
    this.codesToAdd = this.codesToAdd.filter((code) => {
      return code != codeToRemove;
    });
  }


  changeTriggerType(triggerType) {
    this.promotion.rewardTrigger = triggerType;
  }


  changeTrigger($event, trigger) {
    console.log($event.target.checked);
    console.log(trigger);
    if (trigger.promotionTrigger === this.PROMOTBYRECHARGE) {
      this.showInputAmountForCharge = !this.showInputAmountForCharge;
    }
    if ($event.target.checked) {
      this.promotionTriggersToSave.push(trigger.id);
    } else {
      this.promotionTriggersToSave.splice(this.promotionTriggersToSave.indexOf(trigger.id), 1);
    }
    console.log(this.promotionTriggersToSave);
  }

  fileCodesUpload(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (file.size > 0) {
        console.log('File Size');
        console.log(file.size);
        this.fileCodes = file;
        // const formData: FormData = new FormData();
        // formData.append('fileCodes', file, file.name);
        // formData.append('promotionKey', this.promotionKey);
        // formData.append('promotionType', null);
        // formData.append('numeroCodigos', null);
        // console.log('PromocionesComponent#fileCodesUpload:fileName');
        // console.log(file.name);
        // console.log(formData.get('file'));
        // this.uploadCodes(formData);
      } else {
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Archivo de codigos vacio'
        });
      }
    }
    // this.inputCodes.nativeElement.value = "";
  }


  private getGamesForPromotion() {
    this.promocionesService.getGamesForPromotion().subscribe(games => {
      console.log('Juegos para promocion:', games);
      this.gamesToPromotion = games;
      if (!this.newPromotion) {
        this.retrievePromotion(this.promotionKey);
      } else {
        this.initForm(null);
        this.promotion.principal = false;
        this.getPromotionTriggers();
      }
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/ganalottodo/admin-promotion/ganalottodo-promotion.component.ts